export const ORANGE_CONTEXT_LIST = [
  'orangedoppayment',
  'njumobile',
  'njumobileweb'
]
